<template>
    <div class="fids-section" v-if="config" :id="`stage-content-${stage}`">
        <div class="head px-4 py-3" :style="`background-color: ${config.color}`">
            {{ config.name }}
        </div>

        <div class="px-4 py-3 mb-4">

            <div class="mb-4">
<!--                <h5>About This Stage</h5>-->
                <stage-mission class="flex-grow-1"
                               :stage="stage"
                               :path="path"
                               :editable="editable"/>
            </div>

            <h5>Teacher Notes</h5>
            <lesson-plan :path="path" :stage="stage" :editable="editable && $page.props.user.is_admin" />

        </div>

        <div class="px-4 py-3 mb-5">

            <div v-for="(section, idx) in activity_sections" :key="section.id"
                 class="mb-4">

                <h5>Student Activities</h5>
                <combined-activity-section :number="idx + 1"
                                           :stage="stage"
                                           :path="path"
                                           :section="section"
                                           :editable="editable"
                                           @combined-activities-changed="combinedActivitiesChanged($event)"
                                           @edit-activity-section="editActivitySection(idx, section)"/>
            </div>

            <div v-if="editable && !is_project" class="add-activity-section">
                <button class="btn btn-primary"
                        @click="addActivitySection()">Add Activity Group</button>
            </div>

        </div>

        <modal :id="utils.randomId({prefix: 'modal'})"
               :show="activitySection.show"
               v-if="activitySection.show"
               size="lg"
               @close="activitySection.show = false">
            <template #title>
                {{ activitySection.idx < 0 ? 'Add' : 'Edit' }} Activity Group
            </template>


            <div class="form-group">
                <input type="text"
                       class="form-control"
                       v-model="activitySection.name"
                       placeholder="Group Name">
            </div>

            <div class="form-group">
                <textarea class="form-control"
                          v-model="activitySection.description"
                          rows="10"
                          placeholder="Group Description"></textarea>
            </div>

            <template #footer>
                <button type="button"
                        @click="activitySection.show = false"
                        class="btn btn-warning">Cancel</button>
                <button v-if="activitySection.idx >= 0"
                        type="button"
                        @click="deleteActivitySection(activitySection.idx)"
                        class="btn btn-danger">Delete</button>
                <button type="button"
                        @click="saveActivitySection()"
                        class="btn btn-success ml-auto">Save</button>
            </template>
        </modal>

    </div>
</template>

<script>
import draggable from 'vuedraggable';
import StageMission from "@/Components/LearningPath/StageMission";
import Resource from "@/Components/LearningPath/Resource";
import ActivitySection from "@/Components/LearningPath/ActivitySection";
import CombinedActivitySection from "@/Components/LearningPath/CombinedActivitySection";
import LessonPlan from "@/Components/LearningPath/LessonPlan";
import Modal from "@/Components/Common/Modal";
import utils from "@/mixins/utils";
export default {
    name: "FidsSection",
    components: {Modal, draggable, Resource, StageMission, ActivitySection, CombinedActivitySection, LessonPlan},
    props: ['stage', 'path', 'editable', 'is_project'],
    emits: ['activities-changed', 'activity-group-changed', 'resource-changed', 'combined-activities-changed'],
    mixins: [utils],

    data(){
        return {

            activitySection: {
                idx: -1,
                name: '',
                description: '',
                show: false,
            },
            mission: {
                idx: -1,
                title: '',
                hint: '',
                show: false,
            },
            activities: [],
            cache: {
                resources: {},
            }
        };
    },

    computed: {

        config(){
          return this.path.fragments[ `stage_${this.stage}_config` ];
        },

        lesson_plan(){
          return this.path.fragments[ `stage_${this.stage}_lesson_plan` ];
        },

        mission_questions: {
            get(){
                return this.path.fragments[ `stage_${this.stage}_mission_questions` ]
            },
            set( questions ){
                this.path.fragments[ `stage_${this.stage}_mission_questions` ] = questions;
            }
        },

        resources:{
            get(){
                const resources = typeof this.path.fragments[ `stage_${this.stage}_resources` ] === 'undefined' ? [] : this.path.fragments[ `stage_${this.stage}_resources` ]
                return resources.map(r => ({key: this.utils.randomId({prefix: 'res'}), id: r}))
            },
            set(resources){
                this.path.fragments[ `stage_${this.stage}_resources` ] = resources.map(r => r.id);
            }
        },

        activity_sections:{
            get(){
                return typeof this.path.fragments[ `stage_${this.stage}_activity_sections` ] === 'undefined' ? [] : this.path.fragments[ `stage_${this.stage}_activity_sections` ];
            },
            set(value){
                this.path.fragments[ `stage_${this.stage}_activity_sections` ] = value;
            }
        },
    },


    methods: {


        addActivitySection(){
            this.activitySection.name = '';
            this.activitySection.description = '';
            this.activitySection.idx = -1;
            this.activitySection.show = true;
        },

        editActivitySection(idx, section){
            this.activitySection.name = section.name;
            this.activitySection.description = section.description;
            this.activitySection.idx = idx;
            this.activitySection.show = true;
        },

        deleteActivitySection(idx){
            if( !confirm('Are you sure to delete this section?') ) return;
            // TODO: Delete the activities inside the section first, then delete the section.
            this.activity_sections.splice(idx, 1);
            this.$emit('activity-group-changed', {stage: this.stage, sections: this.activity_sections});

            this.activitySection.name = '';
            this.activitySection.description = '';
            this.activitySection.idx = -1;
            this.activitySection.show = false;
        },

        saveActivitySection(){

            if( this.activitySection.idx < 0 ){
                this.activities[ this.activity_sections.length ] = [];
                this.activity_sections.push({
                    id: this.utils.randomId({prefix: 'ac'}),
                    name: this.activitySection.name,
                    description: this.activitySection.description,
                });
            }else{
                this.activity_sections[ this.activitySection.idx ].name = this.activitySection.name;
                this.activity_sections[ this.activitySection.idx ].description = this.activitySection.description;
            }

            this.$emit('activity-group-changed', {stage: this.stage, sections: this.activity_sections});

            this.activitySection.name = '';
            this.activitySection.description = '';
            this.activitySection.idx = -1;
            this.activitySection.show = false;

        },


        combinedActivitiesChanged(change){
            this.$emit('combined-activities-changed', change);
        },


        resourceChanged(change){
            change.resources = change.resources.map(r => r.id);
            this.$emit('resource-changed', change);
        },

        removeResource(idx){
            this.resources = this.resources.filter((r, i) => i !== idx);
            this.resourceChanged({stage: this.stage, resources: this.resources});
        },


        addMission(){
            this.mission.idx = -1;
            this.mission.title = '';
            this.mission.hint = '';
            this.mission.show = true;
        },


        selectMission(idx){
            this.mission.idx = idx;
            this.mission.title = this.mission_questions[ idx ].title;
            this.mission.hint = this.mission_questions[ idx ].hint;
            this.mission.show = true;
        },

        saveMission(){

            if( this.mission.idx < 0 ){
                this.mission_questions.push({
                    id: this.utils.randomId({prefix: 'mission'}),
                    title: this.mission.title,
                    hint: this.mission.hint,
                });
            }else{
                if( typeof this.mission_questions[ this.mission.idx ].id === 'undefined' ){
                    this.mission_questions[ this.mission.idx ].id = this.utils.randomId({prefix: 'mission'});
                }
                this.mission_questions[ this.mission.idx ].title = this.mission.title;
                this.mission_questions[ this.mission.idx ].hint = this.mission.hint;
            }

            this.$emit('mission-statement-changed', {stage: this.stage, missions: this.mission_questions});

            this.mission.title = '';
            this.mission.hint = '';
            this.mission.idx = -1;
            this.mission.show = false;
        },

        deleteMission(){
            this.mission_questions.splice( this.mission.idx, 1 );

            this.mission.title = '';
            this.mission.hint = '';
            this.mission.idx = -1;
            this.mission.show = false;

            this.$emit('mission-statement-changed', {stage: this.stage, missions: this.mission_questions});
        },

    },

}
</script>
<style lang="scss" scoped>
.head{
    background-color: $dark;
    font-size: 1.3rem;
    color: white;
}
.question{
    margin-bottom: 1.5rem;

    &:last-child{
        margin-bottom: 0;

        h5{
            margin-bottom: 0;
        }
    }

    &:hover{
        cursor: text;
        background: rgba(black, 0.05);
    }
}

.resources{
    margin-left: -0.3rem;
    margin-right: -0.3rem;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;

    .item{
        display: flex;
        padding: 0 0.3rem;
        margin-bottom: 0.6rem;
        flex: 0 0 100%;

        @include media-breakpoint-up(md){
            flex: 0 0 50%;
        }

        @include media-breakpoint-up(xl){
            flex: 0 0 20%;
        }
    }
}

.empty-resource-block{
    min-height: 100px;

    &:before{
        content: 'Drag resources here to add into learning path.';
        padding: 1rem;
        border-radius: 0.3rem;
        font-style: italic;
        color: darken( $light-borders, 25% );
        z-index: -1;
        position: absolute;
        max-width: 120px;
    }
}

.empty-activity-block{
    min-height: 100px;

    &:before{
        content: 'Drag activities here to add into learning path.';
        padding: 1rem;
        border-radius: 0.3rem;
        font-style: italic;
        color: darken( $light-borders, 25% );
        z-index: -1;
        position: absolute;
        max-width: 120px;
    }
}

</style>
